import { Notifications } from "../../../notifications";
export class Product {
    constructor(topic) {
        this.topic = topic;
        topic.addOnChange((topicSelectElement) => {
            this.showProducts(topicSelectElement);
        });
    }
    showProducts(topicSelectElement) {
        this.hideAllProducts();
        this.uncheckAllProducts();
        this.showProductsSelectedTopic(topicSelectElement);
    }
    showProductsSelectedTopic(topicSelectElement) {
        const topicId = topicSelectElement.value;
        const productsWrapper = document.querySelectorAll(Product.topicProductsWrapperSelector(topicId));
        if (productsWrapper) {
            productsWrapper.forEach((element) => element.classList.remove("hidden"));
        }
    }
    hideAllProducts() {
        const productsWrappers = document.querySelectorAll(Product.productsWrapperSelector);
        productsWrappers.forEach((productsWrapper) => {
            productsWrapper.classList.add("hidden");
        });
    }
    uncheckAllProducts() {
        const products = document.querySelectorAll(`${Product.productsWrapperSelector} input`);
        products.forEach((product) => {
            product.checked = false;
        });
    }
    addToFormData(formData) {
        const products = document.querySelectorAll(`${Product.productsWrapperSelector} input:checked`);
        products.forEach((product) => {
            formData.append(product.name, product.value);
        });
    }
    validate() {
        const products = document.querySelectorAll(`${Product.productsWrapperSelector} input:checked`);
        if (products.length <= 0) {
            Notifications.error(requiredField);
            return false;
        }
        return true;
    }
}
Product.productsWrapperSelector = ".js-products";
Product.topicProductsWrapperSelector = (topicId) => `.js-products-${topicId}`;
